import './about.css'
function About() {
    return <div className="about-space">
        <text className='header-text'>
            about
        </text>
        <text>
            Emilio Ramos de la Fuente, cuban emerging artist interested in new media,digital art and photography always taking into account the essence of traditional art, has participated in several important art events such as ArtBasel Miami NFTs and selected by Time's Pices in the curatorship of Keith Grossman, president of Time for NFTs Liverpool where his work was exhibited and auctioned.
        </text>
        <img
            className='artist-image'
            src={process.env.PUBLIC_URL + "/images/others/artist.png"}
            alt="" />
        <p>
            In my artistic production I am interested in representing and exposing my reflections on issues related to art itself and to the artist himself. With the commodification and consumerism of the world, of life and of everything that surrounds us; The language of art has been losing its founding and nominative condition to acquire a merely instrumental function. Facing issues such as technical reproducibility that calls into question the concept of aura.
        </p>
        <p>
            The aura as the singularity and the experience of the unrepeatable, which tries to destroy originality, assuming the reproductions as massive and not unique apparitions. I advocate the supremacy of pure plastic sensibility over all materialistic ends. My great intention is to create a composition that can exist independently of visual references of the real world and to seek a universal language that transmits and compiles my ideas. For me the beauty of art lies in the formal simplification
        </p>
    </div>
}
export default About